module.exports = __webpack_public_path__ + "img/npslogo.a890eda3.png";